@if (title(); as title) {
  <h3 class="mui-modal__title" [id]="titleId()">
    {{ title }}
  </h3>
}
@if (!hideCloseButton()) {
  <button
    mui-icon-btn
    icon="times"
    type="button"
    class="mui-modal__close-btn"
    [label]="closeButtonLabel() ?? (translations$ | async)?.closeButton"
    [appearance]="'ghost'"
    (click)="onDismiss()">
  </button>
}
<ng-content></ng-content>
